import { WcDatepicker } from 'wc-datepicker/dist/components/wc-datepicker';
// import 'wc-datepicker/dist/themes/light.css';
customElements.define('wc-datepicker', WcDatepicker);

document.querySelectorAll('.reserve_form-section').forEach(section => {
    const locationElem = section.querySelector('[data-field="location"] select');
    const locationOptions = Array.from(locationElem.options);
    locationOptions.forEach(option => {
        if(option.label.trim() === '') {
            option.remove();
        } else if(option.value.trim() === '') {
            option.disabled = true;
        }
    });

    const emailElem = section.querySelector('[data-field="email"] input');
    const repeatEmailElem = section.querySelector('[data-field="email_repeat"] input');

    const customEmailRepeatValidator = () => {
        if(emailElem.value !== repeatEmailElem.value) {
            repeatEmailElem.setCustomValidity('De e-mailadressen komen niet overeen.');
        } else {
            repeatEmailElem.setCustomValidity('');
        }
    }

    emailElem.addEventListener('input', customEmailRepeatValidator);
    repeatEmailElem.addEventListener('input', customEmailRepeatValidator);

    const startDateElem = section.querySelector('[data-field="date_start"] input');
    const endDateElem = section.querySelector('[data-field="date_end"] input');

    const privacy = section.querySelector('.reserve_form-section-privacy');
    const inner = section.querySelector('.datepicker-inner');
    inner.classList.add('invalid');
    const wrapper = section.querySelector('.reserve_form-section-datepicker');
    const datepicker = wrapper.querySelector('wc-datepicker');
    datepicker.firstDayOfWeek = 1;
    datepicker.range = true;
    datepicker.locale = 'nl-NL';
    datepicker.addEventListener('selectDate', function(event) {
        if(event.detail.length == 2){
            startDateElem.value = event.detail[0];
            endDateElem.value = event.detail[1];

            const dateFormat = ['nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }];
            if(window.innerWidth < 1024){
                dateFormat[1] = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' };
            }

            const startDateFormatted = new Date(event.detail[0]).toLocaleDateString(...dateFormat);
            const endDateFormatted = new Date(event.detail[1]).toLocaleDateString(...dateFormat);

            datepickerValue.innerHTML = `${startDateFormatted}<br>${endDateFormatted}`;
            inner.classList.remove('invalid');
        } else {
            startDateElem.value = '';
            endDateElem.value = '';
            datepickerValue.innerHTML = datepickerValueOriginal;
            inner.classList.add('invalid');
        }


        if(event.detail.length == 1){
            wrapper.classList.add('last');
        } else {
            wrapper.classList.remove('last');
        }

    });
    datepicker.disableDate = function(date) {
        // disable past dates
        return date < new Date();
    }

    const formFields = section.querySelector('.b-form-fields');
    const datepickerElement = section.querySelector('.datepicker');
    formFields.appendChild(datepickerElement);
    formFields.appendChild(privacy);
    datepickerElement.appendChild(wrapper);

    const datepickerValue = section.querySelector('.datepicker-value');
    const datepickerValueOriginal = datepickerValue.innerHTML;

    inner.addEventListener('click', function() {
        wrapper.classList.toggle('datepicker-active');
    });
    document.addEventListener('click', function(event) {
        if(
            !wrapper.contains(event.target) &&
            !datepicker.contains(event.target) &&
            !datepickerElement.contains(event.target)
        ){
            wrapper.classList.remove('datepicker-active');
        }
    });
});